// Libraries.
//import pace from 'pace-progress';
// import picturefill from 'picturefill';
import svg4everybody from 'svg4everybody'

// Modules.
import { init as lazyLoad } from './modules/lazyload'
import 'owl.carousel'
import 'jquery'
// import masonry from './modules/masonry';

// Components.
import accordion from './components/accordion'
import dropdown from './components/dropdown'
import featured from './components/featured'
import filters from './components/filters'
import jumpers from './components/jumpers'
import navClose from './components/nav-close'
import navMenu from './components/nav-menu'
import navToggle from './components/nav-toggle'
import scrolling from './components/scrolling'
import search from './components/search'
import searchSoft from './components/search-soft'
import slider from './components/slider'

function init() {
  // Libraries.
  svg4everybody()

  // Modules.
  lazyLoad()

  // Components.
  accordion()
  dropdown()
  featured()
  filters()
  jumpers()
  navClose()
  navMenu()
  navToggle()
  scrolling()
  search()
  searchSoft()
  slider()

  // window.$ = $;
  // window.jQuery = jQuery;
}

export default init
